import React from 'react'
import {
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextField,
  Checkbox,
  FormControl,
  FormLabel,
  Switch,
} from '@mui/material'
import { removeItemFromArray } from '../../../utils/array'

// TECH-DEBT: shouldn't have to do this. fix what we insert into data_type column
const TYPES_MAP = {
  dropdown: null,
  integer: 'number',
  string: 'text',
}

const CustomField = (props) => {
  const {
    field: { id, name, typeId, options = [] },
    types,
    onChange,
    value = '',
    editing,
  } = props
  const type = types.find((t) => t.id === typeId)

  if (type.dataType === 'checkbox') return <CheckboxCustomField {...props} />
  if (type.dataType === 'boolean')
    return (
      <FormControlLabel
        label={name}
        control={
          <Switch
            checked={value || value === 'true'}
            onChange={(e) => onChange(id, e.target.checked)}
          />
        }
      ></FormControlLabel>
    )
  return (
    <TextField
      label={name}
      onChange={(e) => {
        onChange(id, e.target.value)
      }}
      type={TYPES_MAP[type.dataType]}
      fullWidth
      margin='dense'
      select={type.dataType === 'dropdown'}
      value={value}
      disabled={!editing}
    >
      {options.map((o, i) => (
        <MenuItem key={i} value={o.id}>
          {o.name}
        </MenuItem>
      ))}
    </TextField>
  )
}

const CheckboxCustomField = ({
  field: { id, name, options = [] },
  onChange,
  value = [],
  editing,
}) => {
  const handleChange = (optionId, checked) => {
    let newVal = [...value]

    if (checked) newVal.push(optionId)
    if (!checked) newVal = removeItemFromArray(newVal, optionId)

    onChange(id, [...new Set(newVal)])
  }

  return (
    <FormControl>
      <FormLabel>{name}</FormLabel>
      <FormGroup>
        {options.map((o) => {
          return (
            <FormControlLabel
              key={o.id}
              control={
                <Checkbox
                  disabled={!editing}
                  checked={(value || []).includes(o.id)}
                  onChange={(_, checked) => handleChange(o.id, checked)}
                  name={o.name}
                />
              }
              label={o.name}
            />
          )
        })}
      </FormGroup>
    </FormControl>
  )
}

export default CustomField
